export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20overlapping%20curves%20in%20coral%20red%20and%20deep%20amber%20tones%2C%20dark%20atmospheric%20edges%2C%20cinematic%20lighting%20with%20subtle%20glow%20effects%2C%20modern%20streaming%20platform%20vibe%2C%20elegant%20and%20sophisticated%20mood%2C%20no%20text%2C%20abstract%20digital%20art%20style&width=1920&height=1080&seq=hero-bg-durian-01&orientation=landscape"
          alt="榴莲视频平台背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          {/* Left: Text */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tag */}
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 mb-5">
              <i className="ri-fire-fill text-accent-400 text-sm"></i>
              <span className="text-accent-300 text-sm font-medium">每日更新 · 万部资源</span>
            </div>

            {/* H1 */}
            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-4">
              榴莲视频 · 你的
              <span className="text-accent-400">高清观影</span>
              首选
            </h1>

            {/* Slogan */}
            <p className="text-lg md:text-xl text-background-50/70 font-light mb-6 max-w-xl mx-auto lg:mx-0">
              海量资源 · 极速播放 · 每日新鲜
            </p>

            {/* Intro */}
            <p className="text-sm md:text-base text-background-50/60 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              榴莲视频聚合香蕉视频、红桃视频、91视频、蜜桃视频、樱花视频等主流品牌高清资源，
              覆盖热门分类与实时更新频道。无需注册即可在线高速播放，全终端自适应，
              每日更新数百部精选内容，是你身边最便捷的免费视频大全。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-movie-line text-primary-400 text-sm"></i>
                </div>
                <span className="text-background-50/80 text-sm">日更 300+ 部</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-user-smile-line text-accent-400 text-sm"></i>
                </div>
                <span className="text-background-50/80 text-sm">千万用户信赖</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-shield-check-line text-primary-400 text-sm"></i>
                </div>
                <span className="text-background-50/80 text-sm">安全无广告</span>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-center cursor-pointer shadow-lg shadow-primary-500/30"
              >
                立即免费观看
              </a>
              <a
                href="#about"
                className="w-full sm:w-auto px-8 py-3 bg-background-50/10 text-background-50 border border-background-50/20 font-medium rounded-full hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                了解更多
              </a>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="flex-1 w-full max-w-md lg:max-w-none mx-auto">
            <div className="relative">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden border border-background-50/10 shadow-2xl shadow-black/40">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20streaming%20platform%20interface%20mockup%20with%20dark%20theme%2C%20video%20thumbnail%20grid%20layout%2C%20warm%20coral%20and%20amber%20accent%20colors%2C%20modern%20UI%20design%2C%20floating%20glass%20cards%20effect%2C%20soft%20glow%20highlights%2C%20futuristic%20entertainment%20app%20aesthetic%2C%20clean%20and%20sophisticated%20look&width=800&height=600&seq=hero-visual-durian-01&orientation=landscape"
                  alt="榴莲视频平台界面预览"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Floating badge */}
              <div className="absolute -bottom-4 -right-4 bg-background-50 rounded-xl px-4 py-3 shadow-lg border border-background-200/60">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                  <span className="text-foreground-950 text-xs font-medium whitespace-nowrap">实时在线 12.8 万人</span>
                </div>
              </div>
              {/* Floating badge 2 */}
              <div className="absolute -top-4 -left-4 bg-background-50 rounded-xl px-4 py-3 shadow-lg border border-background-200/60">
                <div className="flex items-center gap-2">
                  <i className="ri-star-fill text-accent-500 text-sm"></i>
                  <span className="text-foreground-950 text-xs font-medium whitespace-nowrap">评分 4.9 / 5.0</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}